import React from 'react';
import { Star as StarIcon } from 'phosphor-react-native';
import { colors } from '../../theme/theme';

type IconProps = {
  size: number;
  color: string;
};

const Star = ({
  type,
  size,
  color,
}: IconProps & { type: 'full' | 'empty' }) => {
  if (type === 'full') {
    return <StarIcon size={size} color={color} weight="fill" />;
  }

  return <StarIcon size={size} color={colors.gray60} weight="fill" />;
};

export default Star;
